import Vue from "vue";

const END_POINT = "/api/api-keys";

const getAllApiKeys = () => Vue.axios.get(END_POINT);

const createApiKey = apiKey => Vue.axios.post(END_POINT, apiKey);

const updateApiKey = apiKey =>
  Vue.axios.put(END_POINT + "/" + apiKey.id, apiKey);

const deactivateApiKey = id =>
  Vue.axios.patch(END_POINT + "/" + id + "/deactivate");

const deleteApiKey = id => Vue.axios.delete(END_POINT + "/" + id);

export {
  getAllApiKeys,
  createApiKey,
  updateApiKey,
  deactivateApiKey,
  deleteApiKey,
};
